import { createContext, useContext } from "react";

import type { CustomMailSettingTestMailInput } from "@/lib/gql/__generated__/graphql";

import { ProductDayTripPlanFormModelContext } from "../../_shared/context/context";

import type { ProductDayTripPlanFormModelContextType } from "../../_shared/context/context";

export type ProductNewPlanFormModelContextType = {
	onUpdate: () => void;

	testEmailSender: {
		sendTestMailAtReservationCreate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationUpdate: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtReservationCancel: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore07Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckInBefore00Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
		sendTestMailAtCheckOutAfter01Days: (input: CustomMailSettingTestMailInput) => Promise<void>;
	};
} & ProductDayTripPlanFormModelContextType;

export const ProductNewDayTripPlanFormModelContext = createContext<ProductNewPlanFormModelContextType | null>(null);

export const ProductNewDayTripPlanFormModelContextProvider = ({
	value,
	children,
}: {
	value: ProductNewPlanFormModelContextType;
	children: React.ReactNode;
}) => {
	return (
		<ProductNewDayTripPlanFormModelContext.Provider value={value}>
			<ProductDayTripPlanFormModelContext.Provider value={value}>
				{children}
			</ProductDayTripPlanFormModelContext.Provider>
		</ProductNewDayTripPlanFormModelContext.Provider>
	);
};

export const useProductNewDayTripPlanFormModelContext = () => {
	const context = useContext(ProductNewDayTripPlanFormModelContext);

	if (!context) {
		throw new Error(
			"useProductNewDayTripPlanFormModelContext must be used within a ProductNewDayTripPlanFormModelContextProvider",
		);
	}

	return {
		...context,
	};
};
